import React from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { AdditionalInfo } from './AdditionalInfo'

const StudentAdditionalInfo = () => {
	const { studentId } = useParams()
	const { user } = useAuth()
	const isInstructorView = user?.role === 'Instructor'
	const effectiveStudentId = isInstructorView ? studentId : user?.id

	return (
		<StudentTopMenuLayout activeMenu="AddInfo" pageName="AdditionalInfo">
			<AdditionalInfo studentId={effectiveStudentId} />
		</StudentTopMenuLayout>
	)
}

export { StudentAdditionalInfo }
